module.exports = __webpack_public_path__ + "assets/img/2207.c26de450.png";